import React from 'react'
import { Button, IconAdd } from '@dostavkee/web-ui'
import { useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'

import { RecruitmentLimitToastError, useRecruitmentCheckLimit } from '@/entities/recruitment'
import { useDeviceDetect } from '@/shared/model'

export const RecruitmentCreateButton = () => {
    const { checkLimit, isPending } = useRecruitmentCheckLimit()
    const { isMobile, isTablet } = useDeviceDetect()
    const navigate = useNavigate()

    return (
        <Button
            fullWidth={isMobile || isTablet}
            isLoading={isPending}
            prefixEl={<IconAdd color='#fff' />}
            size='large'
            onClick={async () => {
                await checkLimit().then((response) => {
                    const { isReachedLimit, formattedLimitCount, formattedLimitPeriod } = response

                    if (isReachedLimit) {
                        toast.error(
                            <RecruitmentLimitToastError
                                formattedLimitCount={formattedLimitCount}
                                formattedLimitPeriod={formattedLimitPeriod}
                            />,
                            {
                                duration: 5000,
                            }
                        )
                    } else {
                        navigate({ to: '/recruitment/create' })
                    }
                })
            }}
        >
            Добавить водителя
        </Button>
    )
}
